import React, { useState, useEffect } from "react";
import {
  LabelList,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

export default function YearlyPage2({ campaigns }) {
  const [secondChartData, setSecondChartData] = useState([]);
  const [dataSet, setDataSet] = useState(false);
  const [dimensions, setDimensions] = useState({
    width: window.innerHeight + 550,
    height: window.innerHeight / 2,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerHeight + 550,
        height: window.innerHeight / 2,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function updateChartData() {

      let tempData = [];
      // insert an empty data point at the beginning and end of the array to create spacing in the chart
      tempData.push(  {name: "",openRate: null,});

       let tempCampaigns = [...campaigns];
       tempCampaigns.sort((a, b) => new Date(a.sendTime)- new Date(b.sendTime));
       
        tempCampaigns.forEach((campaign) => {
          tempData.push(
{
        name:
          campaign && campaign !== undefined
            ? changeToMonthName(new Date(campaign.sendTime).getMonth() + 1)
            : "",
        openRate: campaign
          ? (
              Math.round(campaign.reportSummary.openRate * 1000).toFixed(
                1
              ) / 10
            ).toLocaleString(undefined, {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1,
            })
          : null,
      },

          );
        });
        
      tempData.push(  {name: "",openRate: null,});
      
      setSecondChartData(tempData);


    // setSecondChartData([
    //   {
    //     name: "",
    //     openRate: null,
    //   },
    //   {
    //     name:
    //       campaigns[11] && campaigns[11] !== undefined
    //         ? changeToMonthName(new Date(campaigns[11].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[11]
    //       ? (
    //           Math.round(campaigns[11].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[10] && campaigns[10] !== undefined
    //         ? changeToMonthName(new Date(campaigns[10].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[10]
    //       ? (
    //           Math.round(campaigns[10].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[9] && campaigns[9] !== undefined
    //         ? changeToMonthName(new Date(campaigns[9].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[9]
    //       ? (
    //           Math.round(campaigns[9].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[8] && campaigns[8] !== undefined
    //         ? changeToMonthName(new Date(campaigns[8].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[8]
    //       ? (
    //           Math.round(campaigns[8].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[7] && campaigns[7] !== undefined
    //         ? changeToMonthName(new Date(campaigns[7].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[7]
    //       ? (
    //           Math.round(campaigns[7].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[6] && campaigns[6] !== undefined
    //         ? changeToMonthName(new Date(campaigns[6].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[6]
    //       ? (
    //           Math.round(campaigns[6].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[5] && campaigns[5] !== undefined
    //         ? changeToMonthName(new Date(campaigns[5].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[5]
    //       ? (
    //           Math.round(campaigns[5].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[4] && campaigns[4] !== undefined
    //         ? changeToMonthName(new Date(campaigns[4].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[4]
    //       ? (
    //           Math.round(campaigns[4].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[3] && campaigns[3] !== undefined
    //         ? changeToMonthName(new Date(campaigns[3].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[3]
    //       ? (
    //           Math.round(campaigns[3].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[2] && campaigns[2] !== undefined
    //         ? changeToMonthName(new Date(campaigns[2].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[2]
    //       ? (
    //           Math.round(campaigns[2].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[1] && campaigns[1] !== undefined
    //         ? changeToMonthName(new Date(campaigns[1].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[1]
    //       ? (
    //           Math.round(campaigns[1].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name:
    //       campaigns[0] && campaigns[0] !== undefined
    //         ? changeToMonthName(new Date(campaigns[0].sendTime).getMonth() + 1)
    //         : "",
    //     openRate: campaigns[0]
    //       ? (
    //           Math.round(campaigns[0].reportSummary.openRate * 1000).toFixed(
    //             1
    //           ) / 10
    //         ).toLocaleString(undefined, {
    //           minimumFractionDigits: 1,
    //           maximumFractionDigits: 1,
    //         })
    //       : null,
    //   },
    //   {
    //     name: "",
    //     opened: null,
    //     views: null,
    //   },
    // ]);
  }

  function changeToMonthName(monthNumber) {
    var month = "";
    if (monthNumber === 1) month = "January";
    else if (monthNumber === 2) month = "February";
    else if (monthNumber === 3) month = "March";
    else if (monthNumber === 4) month = "April";
    else if (monthNumber === 5) month = "May";
    else if (monthNumber === 6) month = "June";
    else if (monthNumber === 7) month = "July";
    else if (monthNumber === 8) month = "August";
    else if (monthNumber === 9) month = "September";
    else if (monthNumber === 10) month = "October";
    else if (monthNumber === 11) month = "November";
    else if (monthNumber === 12) month = "December";
    return month;
  }

  function getMinMax() {
    const maxValue = Math.max(
      ...secondChartData.slice(1, -1).map((item) => Math.max(item.openRate))
    );

    const yMax = Math.ceil(maxValue);

    const yDomain = [0, yMax + 10];
    return yDomain;
  }

  function main() {
    if (!dataSet) {
      updateChartData();
      setDataSet(true);
    } else {
      return (
        <>
          <div className="row content" style={{ height: "fit-content" }}>
            <h1
              className="heading"
              style={{
                width: "fit-content",
                height: "fit-content",
                fontSize: "5.4vh",
                textAlign: "left",
                marginTop: "40px",
                marginBottom: "10vh",
                marginLeft: "40px",
                padding: 0,
              }}
            >
              MONTHLY COMPARISON - OPENS
            </h1>
            <div className="row" style={{ height: "fit-content" }}>
              <div className="row" style={{ height: "fit-content" }}>
                <div className="col-md-12" style={{ height: "fit-content" }}>
                  <div className="legend">
                    <div className="legend-item">
                      <span className="legend-symbol legend-symbol-2">●</span>
                      Open Rate
                    </div>
                  </div>
                </div>
              </div>
              <div className="row chart-container">
                <div className="col-md-12">
                  <LineChart
                    width={dimensions.width}
                    height={dimensions.height}
                    data={secondChartData}
                    margin={{
                      top: 0,
                      right: 0,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis
                      domain={getMinMax()}
                      tickFormatter={(value) => `${value}%`}
                    />
                    <Line
                      className="chart-line"
                      name="Open Rate"
                      type="linear"
                      dataKey="openRate"
                      strokeWidth={3}
                      dot={{ r: 5, className: "chart-dot" }}
                    >
                      <LabelList
                        className="chart-label"
                        dataKey="openRate"
                        position="top"
                        dy={-10}
                        formatter={(value) => `${value}%`}
                      />
                    </Line>
                  </LineChart>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }

  return <>{main()}</>;
}
